module.exports = __webpack_public_path__ + "static/media/0031.1e53b358.jpg";